import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { images } from "@/data/images";
import { blueprint } from "@/data/blueprint";
import {
  Flag, Users, Star, Repeat, MessageSquare, Zap, Shield,
  BookOpen, ClipboardCheck, ListChecks, Award, Check,
} from "lucide-react";

const iconMap = {
  Flag, Users, Star, Repeat, MessageSquare, Zap, Shield,
  BookOpen, ClipboardCheck, ListChecks, Award,
};

export default function Blueprint() {
  return (
    <div data-testid="blueprint-page">
      <PageHeader
        eyebrow="Program Blueprint"
        title="The coaching manual."
        intro="The standards, culture, and systems that define how we operate — from the locker room to the last possession."
        image={images.ballFloor}
      />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blueprint.map((b, i) => {
              const Icon = iconMap[b.icon];
              return (
                <Reveal key={b.id} delay={(i % 3) * 0.06}>
                  <div
                    data-testid={`blueprint-card-${b.id}`}
                    className="group border border-white/10 bg-ink-surface p-7 h-full hover:-translate-y-1 hover:border-white/20 transition-all duration-300"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <span className="h-10 w-10 grid place-items-center bg-burnt/15 text-burnt group-hover:bg-burnt group-hover:text-white transition-colors">
                        <Icon size={20} />
                      </span>
                      <span className="font-mono text-xs text-zinc-600">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <h3 className="font-heading text-xl font-medium text-white">
                      {b.title}
                    </h3>
                    <p className="mt-2 text-sm text-zinc-500 leading-relaxed">
                      {b.summary}
                    </p>
                    <ul className="mt-5 space-y-2.5">
                      {b.points.map((pt, j) => (
                        <li key={j} className="flex gap-2.5 text-sm text-zinc-400">
                          <Check size={16} className="text-gold shrink-0 mt-0.5" />
                          <span className="leading-snug">{pt}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
